var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAb6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 35,
    viewBox: "0 0 187 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3438 29.1307V5.87109H113.794V11.2735H105.369V29.1307H99.3438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.969 29.1307V20.0211H123.018V29.1307H116.992V5.87109H123.018V14.5514H131.969V5.87109H137.994V29.1307H131.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.959 29.1307V11.2735H165.922V5.87109H186.06V11.2735H178.988V29.1307H172.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.059 29.1244V15.8716L147.468 29.1244H142.43V5.87109H148.455V18.986L157.885 5.87109H163.088V29.1244H157.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7133 29.1307V15.3076L58.6974 22.6102L52.6816 15.3076V29.1307H46.6562V5.87109H52.6028L58.6974 13.8689L64.7921 5.87109H70.7385V29.1307H64.7133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1752 20.9464H87.7749L84.975 13.6535L82.1752 20.9464ZM90.9153 29.1237L89.6542 25.8648H80.2867L79.0254 29.1237H72.9688L82.2353 5.86719H87.8065L97.0762 29.1237H90.9153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5965C0.005834 7.78737 1.10668 5.09508 3.06151 3.10905C5.01633 1.12302 7.66585 0.0050796 10.43 0H34.5092V5.38633H10.4363C9.07808 5.39223 7.77713 5.94294 6.81643 6.91867C5.85576 7.89438 5.31306 9.21616 5.30642 10.5965L5.27489 19.6389C5.16499 20.7974 4.68062 21.8862 3.89743 22.7356C3.11426 23.5848 2.07638 24.1465 0.945886 24.3331L0 24.4805V10.5965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 35.0001V29.6136H24.0791C25.4376 29.6069 26.7385 29.0554 27.6992 28.0793C28.6597 27.103 29.2024 25.7809 29.209 24.4004V15.8194C29.2156 14.5744 29.6575 13.3724 30.4557 12.428C31.2539 11.4836 32.3564 10.8583 33.5663 10.6637L34.5122 10.5195V24.4004C34.5063 27.2098 33.4057 29.9024 31.4508 31.8889C29.4962 33.8755 26.8467 34.994 24.0822 35.0001H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4051 24.4982V17.5354L17.2647 21.3452L14.1275 17.5354V24.4982H9.96875V10.7969H13.9068L17.2647 15.2027L20.6226 10.7969H24.5607V24.4982H20.4051Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb6);
export default __webpack_public_path__ + "static/media/ab (6).210801ba60d6d1f7105c0e6aa5a30fc2.svg";
export { ForwardRef as ReactComponent };